import React, { useEffect, useRef, useState } from 'react'
import { Container, Row, Col, Form, Button, Card} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { getCandidate, addCandidateCourse, deleteCandidateCourse } from '../../actions/candidatesActions'
import Swal from 'sweetalert2'
import SubMenuTitles from '../../components/menus/SubMenuTitles'
import { useParams } from 'react-router-dom'

export default function Courses() {
    const {id: candidateId} = useParams() || {}
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()

    const courseDiplomaInput = useRef(null)

    const {candidate, resultcandidate} = useSelector(state=>state.candidates)

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if(client){
            dispatch(getCandidate(candidateId || client?.id))
        }
    },[dispatch, t, client])

    const [courseForm, setcourseForm] = useState({
		name: '',
		studyCentre: '',
        duration: '',
        diplomaUrl: null
    })

    const handleInputNewCourse = ({target})=>{
        setcourseForm({
            ...courseForm,
            [target.name]: target.value
        })
    }

    const handleAddCourse = async(e) => {
        e.preventDefault()

        dispatch(addCandidateCourse(courseForm, candidateId || client?.id))

        setcourseForm({
            name: '',
            studyCentre: '',
            duration: '',
            diplomaUrl: null
        })
        courseDiplomaInput.current.value = null
    }

    const handleDeleteCourse = async(e, course) => {
        e.preventDefault()
 
        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.yes'),
            denyButtonText: t('global.no'),
            icon: 'question',
            text: t('profile.candidate.areyousuredelete')
        }).then((resultuser) => {
            if (resultuser.isConfirmed) {
                dispatch(deleteCandidateCourse(course, candidateId || client?.id))
            }
        })
    }

    useEffect(() => {
        if(resultcandidate){
            switch (resultcandidate) {
                case 'successAddCourse':
                    dispatch(getCandidate(candidateId || client?.id))
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('profile.candidate.successAddCourse')
                    })
                    break;
                case 'errorAddCourse':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('profile.candidate.errorAddCourse')
                    })
                    break;
                case 'successDeleteCourse':
                    dispatch(getCandidate(candidateId || client?.id))
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('profile.candidate.successDeleteCourse')
                    })
                    break;
                case 'errorDeleteCourse':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('profile.candidate.errorDeleteCourse')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultcandidate])

    return (
        <>
            <Container className='cuerpo'>
                <Row className='mb-4'>
                    <Col className='d-flex align-items-center'>
                        <img src="/images/titulosbig.svg" alt="Icono Titulos" />
                        <h1 className='ms-2 m-0'>{t('menus.academic')}</h1>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <Card className='mb-5 sombra lateral' >
                            <Card.Body className='p-0 d-flex'>
                                <div className='d-none d-sm-block submenu-lateral'>
                                    <SubMenuTitles seccion='courses' usertype={candidateId ? 'Superadmin' : 'Candidate'} candidateId={candidateId || client?.id} />
                                </div>
                                <div className='px-5 py-3 contenido-datos'>
                                    <Row className="mt-5 mb-3">
                                        <Col>
                                            <h3>{t('profile.candidate.courses')}</h3>
                                        </Col>
                                    </Row>
                                    <Row className="mt-1 mb-3">
                                        {candidate?.courses?.length > 0
                                            ?
                                                candidate?.courses?.map((course, key) => (
                                                    <Col xs={12} className='bloque-adjuntos d-flex justify-content-between align-items-center' key={key}>
                                                        <div className='d-flex'>
                                                            <div className='me-3'><img src="/images/diploma.svg" className='w-65px' alt="Diploma"/></div>
                                                            <div>
                                                                <h4>{course.name}</h4>
                                                                {course.studyCentre} | {course.duration} ({t('global.hours')})
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <a href={course.diplomaUrl} download target="_blank" rel="noreferrer">
                                                                <i className='fas fa-download'/>
                                                            </a>
                                                            <img src="/images/trash.svg" className='ms-2 cursor' alt="Trash" onClick={e => handleDeleteCourse(e, course._id)} />
                                                        </div>
                                                    </Col>
                                                ))
                                            :
                                                <></>
                                        }
                                    </Row>
                                    <Form onSubmit={handleAddCourse} className='mt-1 mb-3'>
                                        <Row className='my-3'>
                                            <Col xs={12} lg={6}>
                                                <Form.Label>{t('profile.candidate.courseName')}</Form.Label>
                                                <Form.Control
                                                    type='text'
                                                    name='name' 
                                                    value={courseForm.name ||  ''}
                                                    onChange={handleInputNewCourse}
                                                    required
                                                />
                                            </Col>
                                            <Col xs={12} lg={6}>
                                                <Form.Label>{t('profile.candidate.studyCentre')}</Form.Label>
                                                <Form.Control
                                                    type='text'
                                                    name='studyCentre' 
                                                    value={courseForm.studyCentre ||  ''}
                                                    onChange={handleInputNewCourse}
                                                    required
                                                />
                                            </Col>
                                        </Row>
                                        <Row className='my-3'>
                                            <Col xs={12} lg={6}>
                                                <Form.Label>{t('profile.candidate.courseDuration')} ({t('global.hours')})</Form.Label>
                                                <Form.Control
                                                    type='number'
                                                    name='duration' 
                                                    value={courseForm.duration ||  ''}
                                                    onChange={handleInputNewCourse}
                                                    required
                                                />
                                            </Col>
                                            <Col xs={12} lg={6}>
                                                <Form.Label>{t('profile.candidate.uploadCourseDiploma')}</Form.Label>
                                                <Form.Control type='file' required name='diplomaUrl' onChange={(e) => setcourseForm({...courseForm, diplomaUrl: e.target.files[0]})} ref={courseDiplomaInput} />
                                            </Col>
                                        </Row>
                                        <Row className="my-3 d-flex justify-content-end">
                                            <Col xs='12' lg='6'>
                                                <Button type="submit" className="btn-primary w-100 my-2">{t('profile.candidate.addCourse')}</Button>
                                            </Col>
                                        </Row>
                                    </Form>                                    
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
}